import axios from 'axios';
import configService from "../service/config";

axios.defaults.timeout = 15000;

axios.defaults.baseURL = configService.Axios.baseURL[process.env.NODE_ENV];

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// axios.interceptors.request.use(
//     config => {
//         config.headers.appid = configService.appId;
//         if (Vuex.state.token) {
//             config.headers.token = Vuex.state.token;
//         }
//         return config;
//     },
//     err => {
//         return Promise.reject(err);
//     }
// );


export default axios
